import React, { Component } from "react";

class SectionKnowSigmobi extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-5c7b32e6 elementor-section-height-full elementor-hidden-mobile elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
          data-id="5c7b32e6"
          data-element_type="section"
          data-settings='{"background_background":"classNameic"}'
        >
          <div className="elementor-background-overlay"></div>
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7e137976"
              data-id="7e137976"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-3fb81eb7 elementor-widget elementor-widget-text-editor"
                  data-id="3fb81eb7"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      Chegou a{" "}
                      <span style={{ color: "#0097e1" }}>SIG MOBI!</span>
                    </p>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-46f04027 elementor-widget elementor-widget-text-editor"
                  data-id="46f04027"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      Vamos fazer
                      <span style={{ color: "#ef3087" }}>
                        {" "}
                        história juntos?
                      </span>
                    </p>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-21afbe8c elementor-widget elementor-widget-text-editor"
                  data-id="21afbe8c"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      <span style={{ color: "#0097e1" }}>Inovação</span>{" "}
                      acessível para todos!
                    </p>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-9eaa59b elementor-widget elementor-widget-text-editor"
                  data-id="9eaa59b"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      A <span style={{ color: "#0097e1" }}>Sig Mobi</span> está{" "}
                      <span style={{ color: "#ef3087" }}>revolucionando</span> a
                      forma como nos movemos!
                    </p>{" "}
                  </div>
                </div>
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-267aa8d8 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="267aa8d8"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-5bb3529b"
                      data-id="5bb3529b"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-3d38b404 bt-refer cadastro animated-slow elementor-widget elementor-widget-button animated fadeInUp"
                          data-id="3d38b404"
                          data-element_type="widget"
                          data-settings='{"_animation":"fadeInUp","_animation_delay":3000}'
                          data-widget_type="button.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-button-wrapper">
                              <a
                                className="elementor-button elementor-button-link elementor-size-lg"
                                href={this.props.url} style={{backgroundColor: '#57c600'}}
                              >
                                <span className="elementor-button-content-wrapper">
                                  <span className="elementor-button-text">
                                    QUERO ME CADASTRAR AGORA
                                  </span>
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-da0484c"
              data-id="da0484c"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-7526b3b elementor-widget elementor-widget-video"
                  data-id="7526b3b"
                  data-element_type="widget"
                  data-settings='{"youtube_url":"https:\/\/www.youtube.com\/watch?v=RFhDPsMXLXw","yt_privacy":"yes","show_image_overlay":"yes","image_overlay":{"url":"","id":"","size":"","alt":"","source":"library"},"video_type":"youtube","controls":"yes"}'
                  data-widget_type="video.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-wrapper elementor-open-inline">
                      <iframe
                        className="elementor-video"
                        frameBorder="0"
                        allowfullscreen=""
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        title="Sig Mobi Passageiros"
                        width="640"
                        height="360"
                        src="https://www.youtube-nocookie.com/embed/RFhDPsMXLXw?controls=1&amp;rel=0&amp;playsinline=0&amp;modestbranding=0&amp;autoplay=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fsigmobioficial.com&amp;widgetid=1"
                        id="widget2"
                      ></iframe>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-74fb281a elementor-section-height-full elementor-hidden-desktop elementor-hidden-tablet elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
          data-id="74fb281a"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-background-overlay"></div>
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3cc2db5f"
              data-id="3cc2db5f"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-78e374c9 elementor-widget elementor-widget-text-editor"
                  data-id="78e374c9"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      Chegou a{" "}
                      <span style={{ color: "#0097e1" }}>SIG MOBI!</span>
                    </p>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-4d7dd86c elementor-widget elementor-widget-text-editor"
                  data-id="4d7dd86c"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      vamos fazer{" "}
                      <span style={{ color: "#ef3087" }}>história juntos?</span>
                    </p>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-49245a52 elementor-widget elementor-widget-video"
                  data-id="49245a52"
                  data-element_type="widget"
                  data-settings='{"youtube_url":"https:\/\/www.youtube.com\/watch?v=RFhDPsMXLXw","show_image_overlay":"yes","image_overlay":{"url":"","id":"","size":"","alt":"","source":"library"},"video_type":"youtube","controls":"yes"}'
                  data-widget_type="video.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-wrapper elementor-open-inline">
                      <iframe
                        className="elementor-video"
                        frameBorder="0"
                        allowfullscreen=""
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        title="Sig Mobi Passageiros"
                        width="640"
                        height="360"
                        src="https://www.youtube.com/embed/RFhDPsMXLXw?controls=1&amp;rel=0&amp;playsinline=0&amp;modestbranding=0&amp;autoplay=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fsigmobioficial.com&amp;widgetid=3"
                        id="widget4"
                      ></iframe>{" "}
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-14520ef9 elementor-widget elementor-widget-text-editor"
                  data-id="14520ef9"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      <span style={{ color: "#0097e1" }}>INOVAÇÃO</span>{" "}
                      ACESSÍVEL PARA TODOS!
                    </p>
                    <p>
                      A <span style={{ color: "#0097e1" }}>SIG MOBI</span> ESTÁ{" "}
                      <span style={{ color: "#ef3087" }}>REVOLUCIONANDO</span> A
                      FORMA DE COMO NOS MOVEMOS!
                    </p>{" "}
                  </div>
                </div>
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-469229b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="469229b3"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-3467c794"
                      data-id="3467c794"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-1008f4dc bt-refer cadastro animated-slow elementor-widget elementor-widget-button animated fadeInUp"
                          data-id="1008f4dc"
                          data-element_type="widget"
                          data-settings='{"_animation":"fadeInUp","_animation_delay":3000}'
                          data-widget_type="button.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-button-wrapper">
                              <a
                                className="elementor-button elementor-button-link elementor-size-lg"
                                href={this.props.url} style={{backgroundColor: '#57c600'}}
                              >
                                <span className="elementor-button-content-wrapper">
                                  <span className="elementor-button-text">
                                    QUERO ME CADASTRAR AGORA
                                  </span>
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default SectionKnowSigmobi;
